/**
 * InfoBar
 */
import React from 'react';
import { Grid, Cell } from 'ui-component-library/base';
/** An information bar used at the top of the page to display messages. */
var InfoBar = function (_a) {
    var children = _a.children, ariaLabel = _a["aria-label"];
    return (React.createElement("div", { "aria-label": ariaLabel, "data-cid": "InfoBar", className: "relative py-3 overflow-hidden border-b-2 info-bar bg-greyLighter border-greyLight" },
        React.createElement(Grid, { padding: false, className: "pl-4 lg:pl-6" },
            React.createElement(Cell, { span: 12 },
                React.createElement("div", { className: "mx-auto info-bar-text leading-6" }, children)))));
};
export default InfoBar;
